export default __webpack_public_path__ + "static/media/banner.74cd487b.png";